import { ProductResult } from "./product-result";

export class SalesOrderItemResult {
  private productQuantity: number;
  private paymentMethod: number;
  private paymentMethodDescription: string;
  private price: number;
  private unitPrice: number;
  private mdmPrice: number;
  private discount: number;
  private discountValue: number;
  private networkPrice: number;
  private subsidyDiscount: number;
  private subsidyValue: number;
  private cardValue: number;
  private checkoutValue: number;
  private employmentPayrollValue: number;

  constructor(private readonly productResult: ProductResult) {}

  getProductResult(): ProductResult {
    return this.productResult;
  }

  setProductQuantity(value: number): void {
    this.productQuantity = value;
  }

  getProductQuantity(): number {
    return this.productQuantity;
  }

  setPaymentMethod(value: number): void {
    this.paymentMethod = value;
  }

  getPaymentMethod(): number {
    return this.paymentMethod;
  }

  setPaymentMethodDescription(value: string): void {
    this.paymentMethodDescription = value;
  }

  getPaymentMethodDescription(): string {
    return this.paymentMethodDescription;
  }

  setPrice(value: number): void {
    this.price = value;
  }

  getPrice(): number {
    return this.price;
  }

  setUnitPrice(value: number): void {
    this.unitPrice = value;
  }

  getUnitPrice(): number {
    return this.unitPrice;
  }

  setMdmPrice(value: number): void {
    this.mdmPrice = value;
  }

  getMdmPrice(): number {
    return this.mdmPrice;
  }

  setDiscount(value: number): void {
    this.discount = value;
  }

  getDiscount(): number {
    return this.discount;
  }

  setDiscountValue(value: number): void {
    this.discountValue = value;
  }

  getDiscountValue(): number {
    return this.discountValue;
  }

  setNetworkPrice(value: number): void {
    this.networkPrice = value;
  }

  getNetworkPrice(): number {
    return this.networkPrice;
  }

  setSubsidyDiscount(value: number): void {
    this.subsidyDiscount = value;
  }

  getSubsidyDiscount(): number {
    return this.subsidyDiscount;
  }

  setSubsidyValue(value: number): void {
    this.subsidyValue = value;
  }

  getSubsidyValue(): number {
    return this.subsidyValue;
  }

  setCardValue(value: number): void {
    this.cardValue = value;
  }

  getCardValue(): number {
    return this.cardValue;
  }

  setCheckoutValue(value: number): void {
    this.checkoutValue = value;
  }

  getCheckoutValue(): number {
    return this.checkoutValue;
  }

  setEmploymentPayrollValue(value: number): void {
    this.employmentPayrollValue = value;
  }

  getEmploymentPayrollValue(): number {
    return this.employmentPayrollValue;
  }
}
